export const STATUS_WAITING = "A";
export const STATUS_RUNNING = "B";
export const STATUS_SUCCESS = "C";
export const STATUS_FAILED = "D";
